import { useState, useEffect } from 'react';

interface LocationProps {
    latitude: string;
    longitude: string;
    speed: number;
    accuracy: number;
    altitude: number;
    altitudeAccuracy: number;
    heading: number;
}

interface ErrorProps {
    code: any;
    message: string;
}

export const useGeolocation = (watch = false) => {
    const [location, setLocation] = useState<Partial<LocationProps>>({});
    const [locationError, setError] = useState<ErrorProps | undefined>(undefined);

    const handler = ({ coords }) => {
        setLocation(coords);
        setError(undefined);
    };
    const handleErrors = (err) => {
        console.log(err);
        setError(err);
        setLocation({});
    };
    const getLocation = () => navigator.geolocation.getCurrentPosition(handler, handleErrors);

    useEffect(() => {
        if (watch) {
            navigator.geolocation.getCurrentPosition(handler);
            const id = navigator.geolocation.watchPosition(handler);
            return () => navigator.geolocation.clearWatch(id);
        }
    }, [watch]);

    return { location, getLocation, locationError };
};
